// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2D9tX","choiceBoxes":"toolbarselects_choiceBoxes__1cWUu","simpleField":"toolbarselects_simpleField__p7ujf"};